// extracted by mini-css-extract-plugin
export default {"signinForm":"SignInForm_signinForm__Te+tx","message":"SignInForm_message__2GEWf","btn":"SignInForm_btn__5DmWB","btnDiv":"SignInForm_btnDiv__9un1e"};